/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
import React, {
    useCallback,
    useContext,
    useEffect,
    useState
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { useModal } from '@jutro/components';
import { Button } from '@jutro/legacy/components';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { EmailQuoteService, CustomQuoteService, MLPortalSettingsService } from 'gw-capability-quoteandbind';
import { LoadSaveService, CustomQuoteService as GatewayCustomQuoteService } from 'gw-capability-gateway-quoteandbind';
import { MLMultiLobsDataHolderService } from 'ml-services-common-react';
import { MLAgentChoiceReportService, UserService } from 'gw-capability-gateway';
import { MLProductCodeUtil, MLErrorMessageUtil } from 'ml-portals-util-js';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { MLTagManagerService, MLModalService } from 'ml-portals-services-react';
import { FormModalPopover, platformMessages } from 'ml-components-platform-react';
import { GatewayDocumentService } from 'gw-capability-gateway-document';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import metadata from './MLQuotePageProposalComponent.metadata.json5';
import styles from './MLQuotePageProposalComponent.module.scss';
import messages from './MLQuotePageProposalComponent.messages';
import MLCoveragePackageLevelInfoModal from "../MLCoveragePackageLevelInfoModal/MLCoveragePackageLevelInfoModal";
import PATrackEvent from '../../components/TrackEvent/PATrackEvent';
import HOTrackEvent from '../../components/TrackEvent/HOTrackEvent';
import PUMBTrackEvent from '../../components/TrackEvent/PUMBTrackEvent';
import { MVR_ERR1, MVR_ERR2, MVR_ERR3 } from '../../../../override/constants/ml-mvr-constants';

import { IntlContext } from '@jutro/legacy/locale';

const {
    MLRatingForCheckPayment,
    MLRatingForAnnualPayment,
    MLRatingForMortgageePayment,
    MLRatingForMonthlyPayrollDeductPayment,
    MLRatingForBankAccountFullPayment
} = appConfig.mlRatingConfigs;

const { MLUserTypes } = appConfig;

const BOOKROLL_WITH_RATE_CAPPING = 'with_Rate_Capping';
const BOOKROLL_WITHOUT_RATE_CAPPING = 'without_ratecapping';
const ORDER_MVR_STATES = ['NH', 'VT', 'ID', 'CO', 'NM', 'TN', 'MO']
const PRODUCTION = 'producer-engage-farmers-fwsprod-prod';
const DEV_LOCAL = 'localhost';
const FOREMOSTSTAR_URL_CLIENT = 'https://client1.foremoststar.com?fromSource=A360';
const FOREMOSTSTAR_URL_QA = 'https://qacld.foremoststar.com?fromSource=A360';
const FOREMOSTSTAR_URL_PROD = 'https://www.foremoststar.com?fromSource=A360';
const FOREMOSTAGENT_URL_CLIENT = 'https://qa.foremostagent.com/ia/portal/login?fromSource=a360&toSource=fmstar';
const FOREMOSTAGENT_URL_QA = 'https://uat.foremostagent.com/ia/portal/login?fromSource=a360&toSource=fmstar';
const FOREMOSTAGENT_URL_PROD = 'https://foremostagent.com/ia/portal/login?fromSource=a360&toSource=fmstar';

function MLQuotePageProposalComponent(props) {
    const modalApi = useModal();
    const {
        submissionVM,
        quoteVM,
        runMainButton,
        getNameForMainButton,
        isAlaska7Day,
        hasValidationErrors,
        isBookroll,
        isBookrollBundleWithRateCapping,
        getPerTermLabel,
        disableProposalFields,
        updateQuoteVM,
        updateQuotePayment,
        updateCustomQuote,
        markQuoteStale,
        currentUser,
        isMainButtonDisabled,
        onDeliveryPreferenceChange,
        history,
        addBannerMessage,
        removeBannerMessage,
        returnToActivityPage,
        uwIssuesExist,
        showClueReportInfoLabel,
        hasQuoteBlockingUWIssues,
        isSelectedQuoteStale,
        setCurrentPaymentPlan,
        currentPaymentPlan
    } = props;
    const intl = useContext(IntlContext);
    const translator = useTranslator();
    const { authHeader, authUserData } = useAuthentication();

    const {
        showErrorModal,
        showProgressDialog,
        hideProgressDialog
    } = MLModalService();
    const { showReportModalWithSubmissionVM } = MLAgentChoiceReportService();

    const productCode = _.get(submissionVM, 'baseData.productCode.value', '');
    const hoCoveragePartType = _.get(submissionVM, 'lobData.homeowners.coverables.coveragePartType_ML.value.code', '');
    const isPersonalAuto = MLProductCodeUtil.isPersonalAuto(productCode);
    const isHomeowners = MLProductCodeUtil.isHomeOwnersPartialTypeHome(hoCoveragePartType);
    const isCondo = MLProductCodeUtil.isHomeOwnersPartialTypeCondo(hoCoveragePartType);
    const isRenters = MLProductCodeUtil.isHomeOwnersPartialTypeRental(hoCoveragePartType);
    const isLandlordHome = MLProductCodeUtil.isHomeOwnersPartialTypeLandlordHome(hoCoveragePartType);
    const isLandlordCondo = MLProductCodeUtil.isHomeOwnersPartialTypeLandlordCondo(hoCoveragePartType);
    const isLandlordProduct = MLProductCodeUtil.isHomeOwnersPartialTypeLandlordHome(productCode)
        || MLProductCodeUtil.isHomeOwnersPartialTypeLandlordCondo(productCode);
    const isUmbrellaProduct = MLProductCodeUtil.isPersonalUmbrella(productCode);
    const unfilteredTermTypeList = _.get(submissionVM, 'baseData.termType.aspects.availableValues', []);
    const sessionUUID = _.get(submissionVM, 'sessionUUID.value');
    const quoteID = _.get(submissionVM, 'quoteID.value');
    const email = _.get(submissionVM, 'baseData.primaryNamedInsured_ML.value.emailAddress1');
    const isAgent = appConfig.portalCode === 'GPA';
    const isQuoteLocked = isBookrollBundleWithRateCapping || isAlaska7Day;
    const isFromIAPortal = sessionStorage.getItem('fromIAPortal') === 'true';
    const [orderMvrScriptParam, setOrderMvrScriptParam] = useState(false);
    const [orderMvrStatesScriptParam, setOrderMvrStatesScriptParam] = useState([]);
    const [hasMvrBeenOrdered, setHasMvrBeenOrdered] = useState(true);
    const [showMvrCompleteInfoLabel, setShowMvrCompleteInfoLabel] = useState(false);
    const [showMvrWaived, setShowMvrWaived] = useState(false);
    const [droWaiver, setDroWaiver] = useState(true);
    const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false);

    const isModernProductAuto = isModernProduct && isPersonalAuto
    const[isPPPEditable, setIsPPPEditable] = useState(true)

    const generatePaymentPlanCode = (pp) => {
        return `${pp.ratingPaymentMethod_ML}${pp.ratingPaymentSchedule_ML}`;
    };

    const writeValue = useCallback(
        (value, path) => {

            if (path === 'termType_ML' || path === 'commPreference_ML' || path === 'periodStartDate' || path === 'selectedPaymentPlan' || path === 'preferredPaymentMethodInd_Ext') {
                markQuoteStale();
            }

            if (path === 'selectedPaymentPlan') {
                const availablePaymentPlans = _.get(quoteVM, 'value.availablePaymentPlans', []);
                const prevPaymentPlan = _.get(quoteVM, 'value.selectedPaymentPlan', {});
                const selectedPaymentPlan = availablePaymentPlans.find((pp) => generatePaymentPlanCode(pp) === value);

                if (isModernProduct) {
                    if (selectedPaymentPlan?.ratingPaymentSchedule_ML === 'full_pay') {
                        _.set(quoteVM, 'value.preferredPaymentMethodInd_Ext', true);
                    } else {
                        _.set(quoteVM, 'value.preferredPaymentMethodInd_Ext', false);
                    }
                }

                _.set(quoteVM, 'value.selectedPaymentPlan', selectedPaymentPlan);
                _.set(quoteVM, 'value.selectedPaymentPlan.monthlyPremium', prevPaymentPlan?.monthlyPremium);
                _.set(quoteVM, 'value.selectedPaymentPlan.total', prevPaymentPlan?.total);
                setCurrentPaymentPlan(selectedPaymentPlan);
            } else if (isModernProduct && path === 'preferredPaymentMethodInd_Ext') {
                _.set(quoteVM, 'value.preferredPaymentMethodInd_Ext', value);
            } else {
                _.set(quoteVM, path, value);
            }

            updateQuoteVM(quoteVM);
        },
        [markQuoteStale, quoteVM, setCurrentPaymentPlan, updateQuoteVM]
    );

    // To Update the total cost and other values from availableValues
    useEffect(() => {
        const paymentPlan = _.get(quoteVM, 'value.selectedPaymentPlan', undefined);
        const code = generatePaymentPlanCode(paymentPlan)

        if (quoteVM && paymentPlan) {
            const availablePaymentPlans = _.get(quoteVM, 'value.availablePaymentPlans', []);
            const selectedPaymentPlan = availablePaymentPlans.find((pp) => generatePaymentPlanCode(pp) === code);

            _.set(quoteVM, 'value.selectedPaymentPlan', selectedPaymentPlan);
            if (isModernProduct && selectedPaymentPlan?.ratingPaymentMethod_ML === 'mortgagee') {
                setIsPPPEditable(false);
            }
            else {
                setIsPPPEditable(true);
            }
            updateQuoteVM(quoteVM);
        }

    }, [currentPaymentPlan])


    const isQuotePaymentFull = (quote) => {
        return quote.ratingPaymentSchedule_ML === MLRatingForAnnualPayment.ratingPaymentSchedule_ML;
    };

    const isQuotePaymentBankAccount = (quote) => {
        return quote.ratingPaymentMethod_ML === MLRatingForBankAccountFullPayment.ratingPaymentMethod_ML;
    };

    const isQuotePaymentCreditCard = (quote) => {
        return quote.ratingPaymentMethod_ML === MLRatingForAnnualPayment.ratingPaymentMethod_ML;
    };

    const isQuotePaymentCheck = (quote) => {
        return quote.ratingPaymentMethod_ML === MLRatingForCheckPayment.ratingPaymentMethod_ML;
    };

    const isQuotePaymentMortgagee = (quote) => {
        return quote.ratingPaymentMethod_ML === MLRatingForMortgageePayment.ratingPaymentMethod_ML
            && quote.ratingPaymentSchedule_ML === MLRatingForMortgageePayment.ratingPaymentSchedule_ML;
    };

    const isQuotePayrollDeduction = (quote) => {
        return quote.ratingPaymentMethod_ML === MLRatingForMonthlyPayrollDeductPayment.ratingPaymentMethod_ML;
    };

    const getRatedDrivers = (drivers) => (drivers ? drivers.filter((driver) => (driver.type_ML === 'rated' || driver.driverType === 'rated')) : []);

    const getPaymentSchedule = (quote) => {
        if (isQuotePaymentFull(quote)) {
            return translator(messages.payInFull);
        }
        if (isQuotePaymentCheck(quote)) {
            return translator(messages.installments);
        }
        return translator(messages.recurring);
    };

    const getPaymentName = (quote) => {
        let paymentName = '';
        if (isQuotePaymentMortgagee(quote)) {
            return translator(messages.mortgagee);
        }
        if (isQuotePayrollDeduction(quote)) {
            return translator(messages.payrollDeduction);
        }
        if (isQuotePaymentBankAccount(quote)) {
            paymentName += translator(messages.checkingSavingsAcc);
        } else if (isQuotePaymentCreditCard(quote)) {
            paymentName += translator(messages.creditDebitCard);
        } else if (isQuotePaymentCheck(quote)) {
            paymentName += translator(messages.sendBill);
        }
        return paymentName + getPaymentSchedule(quote);
    };

    const openCoveragePackageLevelModal = () => {
        const componentProps = {
            title: messages.offeringDefinitionsLabel,
            overrideProps: {
                isPersonalAuto,
                isHomeowners,
                isRenters,
                isCondo
            },
            CustomComponent: MLCoveragePackageLevelInfoModal,
            actionBtnLabel: commonMessages.close,
            showFooterOnCustomComponent: true
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    };

    const getCoveragePackageLevelContent = () => {
        return (
            <Button type="text" onClick={openCoveragePackageLevelModal}>COVERAGE LEVEL</Button>
        );
    };

    // Dropdowns
    const getAutoTermAvaiableValues = () => {
        const autoTermTypeList = unfilteredTermTypeList.filter((autoTermType) => {
            return autoTermType.code === 'Annual' || autoTermType.code === 'HalfYear';
        });
        return autoTermTypeList.map((availableValue) => ({
            code: availableValue.code,
            name: translator({
                id: availableValue.name,
                defaultMessage: availableValue.name
            })
        }));
    };

    const getCommPrefAvailableValues = () => {
        const commPrefTypelist = _.get(quoteVM, 'commPreference_ML.aspects.availableValues', []);
        const filteredValues = commPrefTypelist.filter((cp) => {
            return cp.code === 'electronic' || cp.code === 'paper';
        });
        return filteredValues.map((availableValue) => ({
            code: availableValue.code,
            name: availableValue.code === 'paper' ? translator(messages.mailCommPref) : translator({
                id: availableValue.name,
                defaultMessage: availableValue.name
            })
        }));
    };


    const getPaymentOptionAvailableValues = () => {
        const availablePaymentPlans = _.get(quoteVM, 'value.availablePaymentPlans', []);
        return availablePaymentPlans.map((pp) => ({
            code: generatePaymentPlanCode(pp),
            name: getPaymentName(pp)
        }));
    };

    const paymentOptionUpdated = (selectedPPcode) => {
        const availablePaymentPlans = _.get(quoteVM, 'value.availablePaymentPlans', []);
        const selectedPaymentPlan = availablePaymentPlans.find((pp) => generatePaymentPlanCode(pp) === selectedPPcode);
        _.set(quoteVM, 'value.selectedPaymentPlan', selectedPaymentPlan);
        updateQuotePayment(selectedPaymentPlan);
    };

    const checkDriversDoNotOrderMvr = (drivers) => {
        let doNotOrderMvr = true;
        drivers.map((driver) => {
            if (!_.isNil(driver.doNotOrderMvr_Ext)) {
                doNotOrderMvr = doNotOrderMvr && driver?.doNotOrderMvr_Ext
            } else {
                doNotOrderMvr = false
            }
        });

        return doNotOrderMvr;
    };

    const checkDriversMvrOrderStatus = (drivers) => {
        let hasBeenOrdered = true;
        drivers.map((driver) => {
            if (!driver?.doNotOrderMvr_Ext && driver?.mvrOrderStatus_Ext !== "Received") {
                hasBeenOrdered = false;
            }
        });

        return hasBeenOrdered;
    };

    const checkDriversMvrReturnedOrWaived = (drivers) => {
        // return true only if all drivers have either received or waived status
        // this is to handle scenarios where we have few drivers as recived and few as waived
        return drivers.every(driver => driver?.mvrOrderStatus_Ext === "Received" || driver?.doNotOrderMvr_Ext === true || driver?.mvrOrderStatus_Ext === "Waived");
    };

    const checkForMvrWaived = (drivers) => {
        // return true only if all drivers have waived status
        return drivers.every(driver => driver?.doNotOrderMvr_Ext === true || driver?.mvrOrderStatus_Ext === "Waived")
    }

    const isPartOfMvrStates = () => {
        const polState = _.get(submissionVM, 'baseData.policyAddress.state.value.code');
        return orderMvrStatesScriptParam.includes(polState);
    };

    useEffect(() => {
        if (!quoteVM.value.selectedPaymentPlan?.ratingPaymentMethod_ML) {
            const availablePaymentPlans = _.get(quoteVM, 'value.availablePaymentPlans', []);
            const hasMortgageePayOption = availablePaymentPlans.some((pp) => {
                return pp.ratingPaymentMethod_ML === 'mortgagee';
            });
            if (hasMortgageePayOption) {
                paymentOptionUpdated('mortgageefull_pay');
            } else {
                paymentOptionUpdated('bank_accountfull_pay');
            }
        }
    }, [quoteVM, paymentOptionUpdated]);

    useEffect(() => {
        MLPortalSettingsService.getSettings(authHeader).then((response) => {
            if (response) {
                if (response.landingPageSettings.enableLandingPageOrderMvr && response.landingPageSettings.enableLandingPageOrderMvrStates) {
                    setOrderMvrScriptParam(response.landingPageSettings.enableLandingPageOrderMvr)
                    const enabledStatesArray = response.landingPageSettings.enableLandingPageOrderMvrStates.split(",");
                    setOrderMvrStatesScriptParam(enabledStatesArray)
                }
            }
        });
    }, [authHeader]);

    useEffect(() => {
        if (isPersonalAuto) {
            const drivers = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers.value');
            setHasMvrBeenOrdered(checkDriversMvrOrderStatus(getRatedDrivers(drivers)));
            setShowMvrCompleteInfoLabel(checkDriversMvrReturnedOrWaived(getRatedDrivers(drivers)));
            setShowMvrWaived(checkForMvrWaived(getRatedDrivers(drivers)));
        } else if (isUmbrellaProduct) {
            const drivers = _.get(submissionVM, 'lobData.personalUmbrella.coverables.vehicleOperators.value');
            setHasMvrBeenOrdered(checkDriversMvrOrderStatus(getRatedDrivers(drivers)));
            setShowMvrCompleteInfoLabel(checkDriversMvrReturnedOrWaived(getRatedDrivers(drivers)));
            setShowMvrWaived(checkForMvrWaived(getRatedDrivers(drivers)));
        }
    }, []);


    useEffect(() => {
        if (isPersonalAuto) {
            const drivers = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers.value');
            setDroWaiver(checkDriversDoNotOrderMvr(getRatedDrivers(drivers)));
        } else if (isUmbrellaProduct) {
            const drivers = _.get(submissionVM, 'lobData.personalUmbrella.coverables.vehicleOperators.value');
            setDroWaiver(checkDriversDoNotOrderMvr(getRatedDrivers(drivers)));
        }
    }, []);

    const formatAmountString = useCallback((value) => {
        const premium = _.get(value, 'amount', 0);
        const currency = _.get(value, 'currency', 'usd');
        try {
            return intl.formatNumber(premium, { style: 'currency', currency });
        } catch (e) {
            return '';
        }
    }, [intl]);

    const showStrikethrough = () => {
        return (_.get(quoteVM, 'value.quoteStatus.isStale', false) || hasValidationErrors(quoteVM.value)) && !isBookroll;
    };

    // Generate Proposal Section
    const emailQuote = useCallback((sessionInfo) => {
        // To be completed
        const isBundleProposal = false;

        const { emailAddress1 } = sessionInfo;
        EmailQuoteService.emailQuote(sessionInfo, isBundleProposal, authHeader).then(() => {
            modalApi.showAlert({
                title: '',
                message: translator(messages.emailQuoteDescription, { emailAddress_ML: emailAddress1 }),
                status: 'info',
                icon: 'mi-error-outline'
            }).catch(_.noop);
        }).catch(() => {
            showErrorModal(messages.error, messages.proposalError);
        });
    }, [authHeader, showErrorModal, translator]);

    // Replacing DownloadDocumentService.getDocument functionality in order to change the filename at portal level. Just like v9 is doing.
    const downloadDocument = useCallback((url, doc) => {
        const httpPromise = fetch(url, authHeader);
        showProgressDialog(platformMessages.downloadingDocument, httpPromise);
        httpPromise.then((response) => {
            if (response.ok) {
                response.blob().then((blob) => {
                    const filename = `${doc.description}.pdf`;
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, filename);
                    } else {
                        const downloadLink = document.createElement('a');
                        downloadLink.setAttribute('href', window.URL.createObjectURL(blob));
                        downloadLink.setAttribute('download', filename);
                        downloadLink.style.display = 'none';
                        document.body.appendChild(downloadLink);
                        downloadLink.click();
                        downloadLink.remove();
                    }
                });
            } else {
                showErrorModal(platformMessages.error, platformMessages.unableToDownloadDocument);
            }
        });
        httpPromise.catch((error) => {
            console.error(error);
            showErrorModal(platformMessages.error, platformMessages.unableToDownloadDocument);
        });
    }, [authHeader, showErrorModal, showProgressDialog]);

    const printQuote = useCallback(() => {
        // EventHub.publish('wizard', 'print');
        const periodID = _.get(quoteVM, 'publicID.value');
        const isBundled = false;
        const createProposalPromise = LoadSaveService.createQuoteProposal(quoteID, periodID, isBundled, authHeader);

        // const displayErrorModal = () => showErrorModal(platformMessages.error, platformMessages.unableToDownloadDocument);

        showProgressDialog(platformMessages.generatingQuoteProposal, createProposalPromise);
        createProposalPromise.then((data) => {
            const docUid = data.docUID;
            const sessionId = data.sessionID;
            const publicId = data.publicID;
            if (docUid) {
                const resp = GatewayDocumentService.downloadDocument(publicId, sessionId);
                showProgressDialog(platformMessages.downloadingDocument, resp);
                resp.catch((error) => {
                    console.error(error);
                    showErrorModal(platformMessages.error, platformMessages.unableToDownloadDocument);
                });

            } else {
                showErrorModal(messages.error, messages.proposalError);
            }
        });
    }, [authHeader, quoteID, quoteVM, showErrorModal, showProgressDialog]);


    const createProposalForAgentType = useCallback(() => {
        printQuote();
    }, [printQuote]);



    const onGenerateProposal = useCallback(() => {
        MLTagManagerService.sendLinkClickEvent('CreateProposal');

        UserService.getCurrentUser(authHeader).then((user) => {
            if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                HOTrackEvent('Cta Clicked', false, submissionVM, user, { action: 'Quote Page Generate Quote Proposal' });
            }
            else if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                PUMBTrackEvent('Cta Clicked', false, submissionVM, user, { action: 'Quote Page Generate Quote Proposal' });
            }
            else {
                PATrackEvent('Cta Clicked', false, submissionVM, user, { action: 'Quote Page Generate Quote Proposal' });
            }
        });

        const postUpdateCallback = createProposalForAgentType;
        if (isBookroll) {
            postUpdateCallback();
        } else {
            updateCustomQuote(quoteVM.value, postUpdateCallback);
        }
    }, [createProposalForAgentType, isBookroll, quoteVM.value, updateCustomQuote]);

    const filterProducerCodes = (target, codes) => {
        return codes.filter((el) => {
            return el.code === target;
        })[0];
    };

    const getCachedProducerCodes = () => {
        return UserService.getCurrentUser(authHeader).then((user) => {
            return user.producerCodes_ML;
        });
    };

    const getProducerCodeIfAvailable = async (code) => {
        const primaryCode = currentUser.primaryProducerCode_ML;
        if (primaryCode && primaryCode.code === code) {
            return primaryCode;
        }

        const cachedCodes = await getCachedProducerCodes();
        if (cachedCodes) {
            return filterProducerCodes(code, cachedCodes);
        }

        return null;
    };

    function consumeCallbacksSequentially(callbackQueue, runOnCompletion, runOnError) {
        if (callbackQueue.length > 0) {
            callbackQueue.shift()().then(
                () => consumeCallbacksSequentially(callbackQueue, runOnCompletion, runOnError),
                (err) => {
                    console.error(err);
                    if (runOnError) {
                        runOnError(err);
                    }
                });
        } else if (runOnCompletion) {
            runOnCompletion();
        }
    }

    const getQuoteCoverages = (subVM, lobPathString, quote) => {
        const offerings = _.get(subVM, `lobData.${lobPathString}.offerings.value`, []);
        const selectedOffering = offerings.find((o) => o.branchCode === quote.branchCode && o.branchName === quote.branchName && o.branchPublicID === quote.publicID);
        return _.get(selectedOffering, 'coverages');
    };

    const saveSubmissionDetailsAndExitFlow = () => {
        const promise = new Promise((resolve, reject) => {
            if (isAgent) {
                if (submissionVM.isChoiceAgentSubmission_ML.value) {
                    showReportModalWithSubmissionVM(submissionVM);
                }
            }

            if (submissionVM.baseData.policyAddress.value.state === 'AK' && submissionVM.baseData.value.termType === '7Days') {
                resolve();
            }
            if (submissionVM.bookrollInd_ML.value && submissionVM.bookrollInd_ML.value.code === BOOKROLL_WITH_RATE_CAPPING ||
                submissionVM.bookrollInd_ML.value.code === BOOKROLL_WITHOUT_RATE_CAPPING) {
                resolve();
            }
            if (!submissionVM.quoteID.value) {
                // no submission was created so just exit without saving
                resolve();
            }

            const isDraftStatus = submissionVM?.baseData?.status_ML?.value === 'Draft';

            if (isDraftStatus && (!submissionVM.aspects.valid || !submissionVM.aspects.subtreeValid)) {
                // invalid data when trying to exit wizard. Exiting without saving
                resolve();
            }

            if (isDraftStatus) {
                return LoadSaveService.updateDraftSubmission(submissionVM.value, authHeader).then(resolve, reject)
                    .catch(error => {
                        if (error.baseError && error.baseError.indexOf('ConcurrentDataChangeException') > -1) {
                            hideProgressDialog();
                            MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
                        } else {
                            throw error
                        }
                    });
            }

            if (submissionVM.isBundle_ML && submissionVM.isBundle_ML.value && MLMultiLobsDataHolderService.getLastVisitedStep() === 'quoteDetails') {
                if (isAgent) {
                    const lobPathString = _.camelCase(_.get(submissionVM, 'baseData.productName.value', ''));
                    const innerPromise = new Promise((innerResolve, innerReject) => {
                        const updateCallbackRequests = submissionVM.value.quoteData.offeredQuotes
                            .map((quote) => {
                                const coverages = {
                                    [`${lobPathString}`]: getQuoteCoverages(submissionVM, lobPathString, quote)
                                };
                                const updateCustomQuoteRequest = {
                                    quote,
                                    sessionUUID: submissionVM.value.sessionUUID,
                                    quoteID: submissionVM.value.quoteID,
                                    ratingPaymentMethod_ML: quote.ratingPaymentMethod_ML,
                                    ratingPaymentSchedule_ML: quote.ratingPaymentSchedule_ML,
                                    productCode_ML: submissionVM.value.baseData.productCode,
                                    forcePaymentMethodSelection_ML: true,
                                    markAsSelectedVersion_ML: quote.publicID === submissionVM.value.bindData.chosenQuote,
                                    coverages: coverages
                                };

                                return async () => {
                                    try {
                                        return await GatewayCustomQuoteService.updateCustomQuote(updateCustomQuoteRequest, authHeader)
                                    } catch (error) {
                                        if (error.baseError && error.baseError.indexOf('ConcurrentDataChangeException') > -1) {
                                            hideProgressDialog();
                                            MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
                                            reject(error)
                                        } else {
                                            throw error
                                        }
                                    }
                                }
                            });

                        consumeCallbacksSequentially(
                            updateCallbackRequests,
                            () => innerResolve(),
                            (err) => innerReject(err)
                        );
                    });

                    innerPromise.then(resolve, reject);

                    return innerPromise;
                }
            }

            if (submissionVM.isBundle_ML &&
                submissionVM.isBundle_ML.value &&
                (MLMultiLobsDataHolderService.getLastVisitedStep() === 'availableDocuments' ||
                    MLMultiLobsDataHolderService.getLastVisitedStep() === 'signAndBind')) {
                return LoadSaveService.preBind(submissionVM.value, authHeader).then(resolve, reject);
            }

            return LoadSaveService.updateQuotedSubmission(submissionVM.value, authHeader).then(resolve, reject)
                .catch(error => {
                    if (error.baseError && error.baseError.indexOf('ConcurrentDataChangeException') > -1) {
                        hideProgressDialog();
                        MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
                    } else if (error.baseError && error.baseError.includes(messages.mvrDMVError.defaultMessage)){
                         hideProgressDialog();
                         addBannerMessage("error", messages.mvrDMVError);
                    } else if (error.baseError 
                        && (error.baseError.includes(MVR_ERR1)
                         || error.baseError.includes(MVR_ERR2) 
                         || error.baseError.includes(MVR_ERR3))) {
                        hideProgressDialog();
                        addBannerMessage("error", messages.mvrTechnicalErrorMessage);
                    }
                    else {
                        throw error
                    }
                });
        });

        showProgressDialog(platformMessages.saveSubmission, promise);

        promise.then(() => {
            if (submissionVM.value.isBundle_ML) {
                MLTagManagerService.sendBundleFormCompleteEvent();
                history.push(`/agent-bundle-cart/${submissionVM.baseData.accountNumber.value}`);
            } else {
                history.push(`/accounts/${submissionVM.baseData.accountNumber.value}/summary`);
            }
        })
            .catch((error) => {
                console.error(error);
                if (error.baseError && error.baseError.indexOf('ConcurrentDataChangeException') > -1) {
                    MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
                }
                return false;
            })
            .finally(() => {
                hideProgressDialog();
            });
    };

    const onSaveToAccount = async () => {
        MLTagManagerService.sendLinkClickEvent('SaveToAccount');

        UserService.getCurrentUser(authHeader).then((user) => {
            if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                HOTrackEvent('Cta Clicked', false, submissionVM, user, { action: 'Quote Page Save to Account' });
            }
            else if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                PUMBTrackEvent('Cta Clicked', false, submissionVM, user, { action: 'Quote Page Save to Account' });
            }
            else {
                PATrackEvent('Cta Clicked', false, submissionVM, user, { action: 'Quote Page Save to Account' });
            }
        });

        const producerCode = _.get(submissionVM, 'baseData.producerCode_ML.value');
        const code = await getProducerCodeIfAvailable(producerCode);
        if (code) {
            CustomQuoteService.updateProducerCode(code, quoteVM.value, sessionUUID, authHeader);
        }
        saveSubmissionDetailsAndExitFlow();
    };

    const isOrderMvrButtonDefaultAvaiable = () => {
        return (isPersonalAuto || isUmbrellaProduct) && isPartOfMvrStates() && orderMvrScriptParam && !droWaiver && !hasMvrBeenOrdered
    };

    const isDriversMvrOptionalDataEmpty = (drivers) => {
        let isEmptyData = false;
        drivers.map((driver) => {
            if (_.isEmpty(driver.licenseNumber) || _.isEmpty(driver.licenseState)) {
                isEmptyData = true;
            }
        });

        return isEmptyData;
    };

    const isDriversLicenseDuplicate = (drivers) => {
        const checkedLicenses = new Set();
        let hasDuplicate = false;

        drivers.forEach((d) => {
            if (checkedLicenses.has(d.licenseNumber)) {
                hasDuplicate = true;
            } else {
                checkedLicenses.add(d.licenseNumber);
            }
        });

        return hasDuplicate;
    };

    const getDisclosuresFromDriver = (driver) => {
        return driver.disclosures_ML || driver.disclosures || driver.disclosure;
    };

    const checkDriversForMvrStatus = (drivers, mvrStatus) => {
        let matchingOrderStatus = false;

        drivers.map((driver) => {
            if (driver?.mvrOrderStatus_Ext === mvrStatus) {
                matchingOrderStatus = true;
            }
        });

        return matchingOrderStatus;
    }

    const onOrderMvr = async () => {
        UserService.getCurrentUser(authHeader).then((user) => {
            if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                HOTrackEvent('Cta Clicked', false, submissionVM, user, { action: 'Quote Page Order MVR' });
            }
            else if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                PUMBTrackEvent('Cta Clicked', false, submissionVM, user, { action: 'Quote Page Order MVR' });
            }
            else {
                PATrackEvent('Cta Clicked', false, submissionVM, user, { action: 'Quote Page Order MVR' });
            }
        });

        removeBannerMessage();

        let drivers;

        if (isPersonalAuto) {
            drivers = _.get(submissionVM, 'lobData.personalAuto.coverables.value.drivers', []);
        } else if (isUmbrellaProduct) {
            drivers = _.get(submissionVM, 'lobData.personalUmbrella.coverables.value.vehicleOperators', []);
        }

        if (isDriversMvrOptionalDataEmpty(getRatedDrivers(drivers))) {
            addBannerMessage("error", messages.mvrOrderedError);
            setHasMvrBeenOrdered(true);
        } else if (isDriversLicenseDuplicate(getRatedDrivers(drivers))) {
            addBannerMessage("error", messages.mvrDuplicateLicenseError);
            setHasMvrBeenOrdered(true);
        } else {
            const orderMvrPromise = LoadSaveService.manualOrderMvr(submissionVM.value, authHeader);

            showProgressDialog(messages.orderMvrLoading, orderMvrPromise);
            orderMvrPromise.then((res) => {
                let drivers = isPersonalAuto ? _.get(res, 'lobData.personalAuto.coverables.drivers') : _.get(res, 'lobData.personalUmbrella.coverables.vehicleOperators');
                let isWaivedStatus = checkForMvrWaived(getRatedDrivers(drivers));
                let isMvrComplete = checkDriversMvrReturnedOrWaived(getRatedDrivers(drivers));
                // setHasMvrBeenOrdered set to true when MVR complete is displayed
                if (isMvrComplete && !isWaivedStatus) {
                    setShowMvrCompleteInfoLabel(true);
                    setShowMvrWaived(false);
                    setHasMvrBeenOrdered(true);
                }
                // setHasMvrBeenOrdered set to false when MVR is not complete
                // US997285: hasMvrBeenOrdered set to true when MVR status is empty to disable the button and show meaningful message.
                else if (!isMvrComplete && !isWaivedStatus) {
                    setShowMvrCompleteInfoLabel(false);
                    setShowMvrWaived(false);
                    addBannerMessage("warningPending", messages.mvrResultsPendingOrDelayed);
                    setHasMvrBeenOrdered(true);
                }
                // setHasMvrBeenOrdered set to true when MVR is waived
                else if (isWaivedStatus) {
                    setShowMvrWaived(true);
                    setHasMvrBeenOrdered(true);
                }
                else {
                    setShowMvrCompleteInfoLabel(true);
                    setHasMvrBeenOrdered(true);
                }
                hideProgressDialog();

                let respDrivers;
                let assignedViolations = [];

                if (isPersonalAuto) {
                    respDrivers = _.get(res, 'lobData.personalAuto.coverables.drivers');
                } else if (isUmbrellaProduct) {
                    respDrivers = _.get(res, 'lobData.personalUmbrella.coverables.vehicleOperators');
                }

                if (respDrivers) {
                    if (isPersonalAuto) {
                        _.set(submissionVM, 'lobData.personalAuto.coverables.drivers', respDrivers)
                    } else if (isUmbrellaProduct) {
                        _.set(submissionVM, 'lobData.personalUmbrella.coverables.vehicleOperators', respDrivers)
                    }
                    const ratedRespDrivers = getRatedDrivers(respDrivers)
                    if (checkDriversMvrOrderStatus(ratedRespDrivers)) {
                        // All Drivers have MVR Order Status as Received
                        ratedRespDrivers.forEach((driver) => {
                            const disclosures = getDisclosuresFromDriver(driver);

                            if (disclosures) {
                                if (!_.isUndefined(disclosures.violations)) {
                                    assignedViolations = assignedViolations.concat(disclosures.violations);
                                }
                            }
                        })

                        if (_.isEmpty(assignedViolations)) {
                            addBannerMessage("success", messages.mvrNoResultsSuccess);
                        }
                        else {
                            returnToActivityPage();
                        }
                    } else if (checkDriversForMvrStatus(ratedRespDrivers, 'Ordered') || checkDriversForMvrStatus(ratedRespDrivers, 'Ready') || checkDriversForMvrStatus(ratedRespDrivers, 'ToBeOrdered')) {
                        addBannerMessage("warningPending", messages.mvrResultsPendingOrDelayed);
                    }
                }


            }).catch((error) => {                
                if (error.baseError&& error.baseError.includes(messages.mvrDMVError.defaultMessage)) {
                    addBannerMessage("error", messages.mvrDMVError);
                    setHasMvrBeenOrdered(true);
                }
                else if (error.baseError && (error.baseError.includes(MVR_ERR1) || error.baseError.includes(MVR_ERR2) || error.baseError.includes(MVR_ERR3))) {
                    addBannerMessage("error", messages.mvrTechnicalErrorMessage);
                    setHasMvrBeenOrdered(true);
                }
            })
        }
    };

    const isForemostStarUser = () => {
        return authUserData && (authUserData.userType === MLUserTypes.IA || authUserData.userType === MLUserTypes.PCS || authUserData.userType === MLUserTypes.MET_GA);
    };

    const onForemostStarClick = () => {
        UserService.getCurrentUser(authHeader).then((user) => {
            if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                HOTrackEvent('Cta Clicked', false, submissionVM, user, { action: 'Quote Page ForemostSTAR' });
            }
            else if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                PUMBTrackEvent('Cta Clicked', false, submissionVM, user, { action: 'Quote Page ForemostSTAR' });
            }
            else {
                PATrackEvent('Cta Clicked', false, submissionVM, user, { action: 'Quote Page ForemostSTAR' });
            }
        });

        let starUrl;

        if (authUserData.userType === MLUserTypes.PCS) {
            if (window.location.hostname.split(".")[0] === PRODUCTION) {
                starUrl = FOREMOSTSTAR_URL_PROD;
            } else if (window.location.hostname.split(".")[0] === DEV_LOCAL) {
                starUrl = FOREMOSTSTAR_URL_CLIENT;
            } else {
                starUrl = FOREMOSTSTAR_URL_QA;
            }
        } else {
            if (window.location.hostname.split(".")[0] === PRODUCTION) {
                starUrl = isFromIAPortal ? FOREMOSTAGENT_URL_PROD : FOREMOSTSTAR_URL_PROD;
            } else if (window.location.hostname.split(".")[0] === DEV_LOCAL) {
                starUrl = isFromIAPortal ? FOREMOSTAGENT_URL_CLIENT : FOREMOSTSTAR_URL_CLIENT;
            } else {
                starUrl = isFromIAPortal ? FOREMOSTAGENT_URL_QA : FOREMOSTSTAR_URL_QA;
            }
        }

        window.open(starUrl, '_blank');
    };

    const isQuotingInProgress = () => {
        return quoteVM && quoteVM.value.showLoading === true;
    };

    const isReadOnly = () => {
        return quoteVM.isReadOnlyML && quoteVM.isReadOnlyML.value;
    };

     useEffect(() => {
        if (
            isModernProduct &&
            _.isNil(_.get(quoteVM, 'value.preferredPaymentMethodInd_Ext'))
        ) {
            _.set(quoteVM, 'value.preferredPaymentMethodInd_Ext', true);
            updateQuoteVM(quoteVM);
        }
    }, [isModernProduct, quoteVM, updateQuoteVM]);

    const overrides = {
        coveragePackageLevelLabel: {
            visible:( !isUmbrellaProduct && !isLandlordProduct && !isModernProduct) || (isModernProduct && (isLandlordCondo || isLandlordHome)),
            content: getCoveragePackageLevelContent()
        },
        coveragePackageLevel: {
            content: _.get(quoteVM, 'coveragePackageLevel_Ext.value'),
            visible: (!isUmbrellaProduct && !isLandlordProduct && !isModernProduct) || (isModernProduct && (isLandlordCondo || isLandlordHome))
        },
        premiumH2: {
            className: showStrikethrough() && !isAlaska7Day ? 'strikethrough' : '',
            content: !isAlaska7Day ? <FormattedMessage
                {...messages.boldValuePerTerm}
                values={{
                    boldValue: (
                        <strong>{formatAmountString(_.get(quoteVM, 'value.selectedPaymentPlan.monthlyPremium'))}</strong>
                    ),
                    term: translator(messages.month)
                }}
            />
                : <FormattedMessage
                    {...messages.boldValuePerTerm}
                    values={{
                        boldValue: (
                            <strong>{formatAmountString(_.get(quoteVM, 'value.selectedPaymentPlan.total'))}</strong>
                        ),
                        term: translator(messages.sevenDays)
                    }}
                />
        },
        totalP: {
            visible: !isAlaska7Day,
            className: showStrikethrough() ? 'strikethrough' : '',
            content: `${formatAmountString(_.get(quoteVM, 'value.selectedPaymentPlan.total'))}/${getPerTermLabel(_.get(quoteVM, 'value.termType_ML'))}`
        },
        totalFees: {
            visible: _.get(quoteVM, 'value.totalChanges_Ext.amount', 0) > 0,
            totalFees: _.get(quoteVM, 'totalChanges_Ext.value', {}),
            itemizedFees: _.get(quoteVM, 'feesCosts_Ext.value', []),
            displayAlternativeTemplate: true
        },
        mainButton: {
            content: getNameForMainButton(),
            disabled: isMainButtonDisabled()
        },
        effectiveDateField: {
            disabled: disableProposalFields(quoteVM)
        },
        termField: {
            disabled: isPersonalAuto ? disableProposalFields(quoteVM) : true,
            availableValues: getAutoTermAvaiableValues()
        },
        commPrefField: {
            disabled: disableProposalFields(quoteVM),
            availableValues: getCommPrefAvailableValues()
        },
        preferredPaymentMethodIndContainer: {
            visible: isModernProduct && _.get(quoteVM, 'value.selectedPaymentPlan', {})?.ratingPaymentSchedule_ML === 'full_pay' && !isUmbrellaProduct
        },

        preferredPaymentMethodIndInput: {
            disabled:  disableProposalFields(quoteVM) || !isPPPEditable
        },
        paymentOptionDropdown: {
            availableValues: getPaymentOptionAvailableValues(),
            disabled: disableProposalFields(quoteVM),
            value: generatePaymentPlanCode(_.get(quoteVM, 'value.selectedPaymentPlan', {}))
        },
        createProposalButton: {
            disabled: hasQuoteBlockingUWIssues || (isSelectedQuoteStale() && !isBookroll)
        },
        saveToAccountButton: {
            disabled: quoteVM.value.showLoading || isQuotingInProgress() || isQuoteLocked || isReadOnly(quoteVM)
        },
        orderMvrButton: {
            visible: isOrderMvrButtonDefaultAvaiable() && !hasMvrBeenOrdered,
            disabled: uwIssuesExist
        },
        foremostStarButton: {
            visible: isForemostStarUser(),
            onClick: onForemostStarClick,
            title: 'Opens in a new tab/window'
        },
        mvrNotOrderedContainer: {
            visible: (isPersonalAuto || isUmbrellaProduct) && (!showMvrCompleteInfoLabel && !showMvrWaived)
        },
        mvrCompleteContainer: {
            visible: (isPersonalAuto || isUmbrellaProduct) && (showMvrCompleteInfoLabel && !showMvrWaived)
        },
        mvrWaivedContainer: {
            visible: (isPersonalAuto || isUmbrellaProduct) && showMvrWaived
        }
    };

    const resolvers = {
        resolveComponentMap: {},
        resolveCallbackMap: {
            onRunMainButton: runMainButton,
            onGenerateProposal,
            onSaveToAccount,
            onOrderMvr
        }
    };


    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={quoteVM}
            classNameMap={styles}
            overrideProps={overrides}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
            onValueChange={writeValue}
        />
    );
}

MLQuotePageProposalComponent.propTypes = {
    submissionVM: PropTypes.shape({}).isRequired,
    quoteVM: PropTypes.shape({}).isRequired,
    runMainButton: PropTypes.func,
    getNameForMainButton: PropTypes.func.isRequired,
    isMainButtonDisabled: PropTypes.func,
    isAlaska7Day: PropTypes.bool,
    hasValidationErrors: PropTypes.func.isRequired,
    isBookroll: PropTypes.bool,
    isBookrollBundleWithRateCapping: PropTypes.bool,
    getPerTermLabel: PropTypes.func.isRequired,
    disableProposalFields: PropTypes.func,
    updateQuoteVM: PropTypes.func.isRequired,
    updateQuotePayment: PropTypes.func.isRequired,
    updateCustomQuote: PropTypes.func.isRequired,
    markQuoteStale: PropTypes.func.isRequired,
    currentUser: PropTypes.shape({}).isRequired,
    onDeliveryPreferenceChange: PropTypes.func.isRequired,
    history: PropTypes.shape({}).isRequired,
    addBannerMessage: PropTypes.func.isRequired,
    aremoveBannerMessage: PropTypes.func.isRequired,
    returnToActivityPage: PropTypes.func.isRequired,
    uwIssuesExist: PropTypes.bool
};

MLQuotePageProposalComponent.defaultProps = {
    runMainButton: _.noop,
    isMainButtonDisabled: _.noop,
    isAlaska7Day: false,
    isBookroll: false,
    isBookrollBundleWithRateCapping: false,
    quoteVM: {},
    disableProposalFields: _.noop
};

export default MLQuotePageProposalComponent;
